import { composeIO } from 'react-compose-io'
import { informacoesModalRegularizacaoSucessoIO } from './InformacoesModalRegularizacaoSucesso.IO'
import { InformacoesModalRegularizacaoSucessoView } from './InformacoesModalRegularizacaoSucesso.View'

export const InformacoesModalRegularizacaoSucesso = composeIO(InformacoesModalRegularizacaoSucessoView, informacoesModalRegularizacaoSucessoIO)
